import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout as AntLayout } from 'antd';
import { useAuthStore } from '@/stores/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import { hasToken } from '@packet/management';

// Components
import Header from './Header';
import GlobalLoading from './GlobalLoading';

// Pages
import TransactionHistory from '@/pages/transaction/TransactionHistory';
import TransactionDetail from '@/pages/transaction/TransactionDetail';
import UtxoManagement from '@/pages/utxo/UtxoManagement';
import UtxoDetails from '@/pages/utxo/UtxoDetails';
import UtxoGenealogy from '@/pages/utxo/UtxoGenealogy';

const { Content } = AntLayout;

const Layout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    hasToken().then((hasToken) => {
      console.log('hasToken: ', hasToken);
      // 如果用户没有token，则跳转到登录页
      if (!hasToken) navigate('/login');
    });
  }, [navigate]);

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Header />
      <Content
        style={{
          background: 'var(--color-page)',
          paddingTop: 'var(--pc-header-height)',
          boxSizing: 'border-box',
        }}
      >
        <Routes>
          <Route path="/transactions" element={<TransactionHistory />} />
          <Route path="/transaction/:chainId/:txhash" element={<TransactionDetail />} />
          <Route path="/utxo" element={<UtxoManagement />} />
          <Route path="/utxo/:networkId/:id" element={<UtxoDetails />} />
          <Route path="/genealogy" element={<UtxoGenealogy />} />
          <Route path="/" element={<Navigate to="/transactions" replace />} />
        </Routes>
      </Content>
      <GlobalLoading />
    </AntLayout>
  );
};

export default Layout;
